import React, { useEffect, useState } from "react";
import { NavLink, useHistory } from "react-router-dom";
import { ListItemButton, ListItemText, Box, Divider, List, Chip } from "@curves/ui-base";
import { NOTIFICATIONS_ROUTER } from "@icoach/router/routerPath";
import useNotificationApi from "@apis/useNotificationApi";
import Logo from "@images/nav_logo.svg";
import { CLUB_HOME_ROUTER } from "@icoach/router/routerPath";
import { isEqual } from "@util/utils";
import { NOTIFICATION_SOURCE_TYPE } from "@icoach/constants/";

const NotificationNavBox = () => {
	const [sourceData, setSourceData] = useState([]);
	const history = useHistory();
	const { getNotificationUnreadApi } = useNotificationApi();
	const totalCount = sourceData.reduce((acc, { count = 0 }) => {
		return acc + count;
	}, 0);

	const handleReturnHomePage = () => {
		history.push(CLUB_HOME_ROUTER.ARRIVE);
	};

	const targetMenuCount = (targetData = [], type = 0) => {
		return targetData.find(({ sourceType }) => isEqual(sourceType, type))?.count ?? 0;
	};

	const initApi = async () => {
		const resp = await getNotificationUnreadApi();
		if (resp) {
			setSourceData(resp);
		}
	};

	useEffect(
		() => {
			initApi();
		},
		// eslint-disable-next-line
		[]
	);

	return (
		<Box className={"notification-menus"}>
			<Box className={"notification-menus-container"}>
				<Box className="logo">
					<img src={Logo} alt="Curves" className="cursor-pointer" onClick={handleReturnHomePage} />
				</Box>
				<List component="div" className="menu" disablePadding>
					<ListItemButton component={NavLink} to={NOTIFICATIONS_ROUTER.ENTIRE} activeClassName="list-item-button-selected">
						<ListItemText primary="全部通知" />
						{!!totalCount && <Chip className="count-dot" label={totalCount} color="error" />}
					</ListItemButton>
				</List>
				<Divider className="mx-2" />
				<List component="div" className="menu" disablePadding>
					<ListItemButton component={NavLink} to={NOTIFICATIONS_ROUTER.MEMBERSHIP_EXPIRE} activeClassName="list-item-button-selected">
						<ListItemText primary="會籍到期" />
						{!!targetMenuCount(sourceData, NOTIFICATION_SOURCE_TYPE.MEMBERSHIPEXPIRED) && (
							<Chip className="count-dot" label={targetMenuCount(sourceData, NOTIFICATION_SOURCE_TYPE.MEMBERSHIPEXPIRED)} color="error" />
						)}
					</ListItemButton>
				</List>
				<List component="div" className="menu" disablePadding>
					<ListItemButton component={NavLink} to={NOTIFICATIONS_ROUTER.TRANSFERIN} activeClassName="list-item-button-selected">
						<ListItemText primary="會籍移入" />
						{!!targetMenuCount(sourceData, NOTIFICATION_SOURCE_TYPE.TRANSFERIN) && (
							<Chip className="count-dot" label={targetMenuCount(sourceData, NOTIFICATION_SOURCE_TYPE.TRANSFERIN)} color="error" />
						)}
					</ListItemButton>
				</List>
				<List component="div" className="menu" disablePadding>
					<ListItemButton component={NavLink} to={NOTIFICATIONS_ROUTER.TRANSFEROUT} activeClassName="list-item-button-selected">
						<ListItemText primary="會籍移出" />
						{!!targetMenuCount(sourceData, NOTIFICATION_SOURCE_TYPE.TRANSFEROUT) && (
							<Chip className="count-dot" label={targetMenuCount(sourceData, NOTIFICATION_SOURCE_TYPE.TRANSFEROUT)} color="error" />
						)}
					</ListItemButton>
				</List>
				<List component="div" className="menu" disablePadding>
					<ListItemButton component={NavLink} to={NOTIFICATIONS_ROUTER.CYCLE_PURCHASE} activeClassName="list-item-button-selected">
						<ListItemText primary="循環訂單" />
						{!!targetMenuCount(sourceData, NOTIFICATION_SOURCE_TYPE.CYCLEPURCHASE) && (
							<Chip className="count-dot" label={targetMenuCount(sourceData, NOTIFICATION_SOURCE_TYPE.CYCLEPURCHASE)} color="error" />
						)}
					</ListItemButton>
				</List>
				<List component="div" className="menu" disablePadding>
					<ListItemButton component={NavLink} to={NOTIFICATIONS_ROUTER.INVOICE} activeClassName="list-item-button-selected">
						<ListItemText primary="發票異常" />
						{!!targetMenuCount(sourceData, NOTIFICATION_SOURCE_TYPE.INVOICE) && (
							<Chip className="count-dot" label={targetMenuCount(sourceData, NOTIFICATION_SOURCE_TYPE.INVOICE)} color="error" />
						)}
					</ListItemButton>
				</List>
				<List component="div" className="menu" disablePadding>
					<ListItemButton component={NavLink} to={NOTIFICATIONS_ROUTER.VERSION_UPDATE} activeClassName="list-item-button-selected">
						<ListItemText primary="新版本" />
						{!!targetMenuCount(sourceData, NOTIFICATION_SOURCE_TYPE.VERSION) && (
							<Chip className="count-dot" label={targetMenuCount(sourceData, NOTIFICATION_SOURCE_TYPE.VERSION)} color="error" />
						)}
					</ListItemButton>
				</List>
			</Box>
		</Box>
	);
};

export default NotificationNavBox;
